var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralAccountIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.979,
    viewBox: "0 0 20 17.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ReferralAccountIcon",
    d: "M18,8a3,3,0,0,1,0,6M10,8V19a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V14m5-6,4.524-3.77A.9.9,0,0,1,18,4.922V17.078a.9.9,0,0,1-1.476.692L12,14H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8Z",
    transform: "translate(-2 -3.021)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralAccountIconDark);
export default __webpack_public_path__ + "static/media/ReferralAccountIconDark.5e2cb733a4e156bfc24416a769f31f30.svg";
export { ForwardRef as ReactComponent };